<oui-dialog-content class="dialog-content">
  <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
  <img
    class="dialog-image image-width"
    alt=""
    src="assets/images/dossier_envoye_icon.svg" />

  <div class="headline-6">Merci et à bientôt !</div>
  <span class="text-md">
    Nous vous remerçions pour votre engagement et votre travail. Si nos chemins se
    croisent à nouveau, nous serions ravis de collaborer ensemble. <br />
    <br />Un e-mail de confirmation de votre choix a été envoyé à votre boîte de
    réception. <br /><br /><br />Bonne continuation et à bientôt !
  </span>
</oui-dialog-content>
